export const couponLabel = (c) =>
  c.type === "percent"
    ? `${c.value}% off${c.max_discount ? ` (up to ₹${c.max_discount})` : ""}`
    : `₹${c.value} off`;

export const couponAmount = (c, base) => {
  const b = Math.max(0, base);
  let amt = c.type === "percent" ? (b * c.value) / 100 : c.value;
  if (c.type === "percent" && c.max_discount) amt = Math.min(amt, c.max_discount);
  return Math.round(Math.min(amt, b));
};

export const couponTitle = (c) => {
  const parts = (c.description || "").split("—");
  return parts.length > 1 ? parts[1].trim() : `${c.code} offer`;
};
